module.exports = __webpack_public_path__ + "static/sahuagin_baron-e6382ef8895a1c768a8583cfb930592c.jpg";